import script from "./Settings.vue?vue&type=script&lang=ts&setup=true"
export * from "./Settings.vue?vue&type=script&lang=ts&setup=true"

import "./Settings.vue?vue&type=style&index=0&id=72c82430&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72c82430"]])

export default __exports__